import React from 'react';
import { useDispatch } from 'react-redux';
import { closeTopOverlayAndHandleHistory, getOverlaysFromUrlHash, getOverlaysHashes } from 'store/slice/overlay';
import { removeHashFromHistory } from 'core-framework/window/history';
import { addEventListenerToWindow, removeEventListenerFromWindow } from 'core/utils/domUtils';

export const OverlayUrlHandler: React.FC = React.memo(() => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        const overlaysFromUrlHash = getOverlaysFromUrlHash();
        if (overlaysFromUrlHash && overlaysFromUrlHash.length > 0) {
            const overlaysHashes = getOverlaysHashes(...overlaysFromUrlHash);
            // Remove Overlay hash from url after page reload
            removeHashFromHistory(overlaysHashes, true);
        }

        const handleBackButton = () => {
            dispatch(closeTopOverlayAndHandleHistory({ shouldGoBack: true }));
        };

        addEventListenerToWindow('hashchange', handleBackButton);
        return () => {
            removeEventListenerFromWindow('hashchange', handleBackButton);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
});
OverlayUrlHandler.displayName = 'OverlayUrlHandler';
